export function findTriggerElement(
    element: HTMLElement | null,
    selector: string
): HTMLElement | null {
    if (element === null) return null;
    if (typeof element.matches !== "function") return null;
    if (element.matches(selector)) {
        return element;
    }
    if (typeof element.parentElement !== "undefined") {
        return findTriggerElement(element.parentElement, selector);
    }
    return null;
}

export function resolvePath(
    path: string,
    object: any,
    separator = "."
): unknown {
    return path
        .split(separator)
        .reduce(
            (prev, curr) =>
                prev === null || prev === undefined ? undefined : prev[curr],
            object
        );
}
